<template>
  <div class="stampbook-container">
    <div class="stampbook-title">
      <div class="stampbook-title__icon">
        <img :src="require(`@/assets/img/icon/svg/icon-stamp.svg`)" />
      </div>
      <div class="stampbook-title__text">
        <span>{{ displayBookName(bookGroup, masterBook) }}</span>
      </div>
    </div>
    <div class="stampbook-content">
      <div v-for="(sheet, index) in sheets" :key="index">
        <ItemIndexStampTile
          :index="index"
          :sheet="sheet"
          :book="book"
          :book-group="bookGroup"
          :is-expired="isExpired"
        />
      </div>
    </div>
    <div class="stampbook-footer">
      <span>
        Copyright© Odakyu Electric Railway Co., Ltd. All Rights Reserved
      </span>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import moment from "@/services/moment";

export default {
  name: "TemplateStampBook",
  setup() {
    const store = useStore();
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const book = computed(() => store.getters["ticketing/book"]);
    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const isExpired = computed(() => {
      const now = moment();
      if (book.value.user_limited_at != null) {
        return moment(book.value.user_limited_at).isBefore(now);
      }

      return moment(book.value.available_limited_at).isBefore(now);
    });

    const sheets = book?.value?.sheets || [];

    return {
      masterBook,
      sheets,
      bookGroup,
      book,
      isExpired,
    };
  },
};
</script>

<style lang="scss" scoped>
.stampbook-container {
  width: 96%;
  margin: 10px auto;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 20px);
}

.stampbook-title {
  display: flex;
  background: #f2f2f2;
  padding: 4vw;
  align-items: center;

  &__text {
    display: flex;
    font-size: 17px;
    font-weight: 700;
    margin-left: 10px;
    line-height: 26px;
  }
}

.stampbook-content {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2%;
  margin-top: 10px;
  overflow: hidden auto;
}

.stampbook-footer {
  font-size: 10px;
  font-weight: 500;
  text-align: center;
  color: #bdbdbd;
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 20px;
}
</style>
